@if (element().deleted_at) {
  <button
    payee-button
    color="white"
    width="shorter"
    [isBorderButton]="true"
    (click)="$event.stopPropagation(); restoreCase()"
  >
    Helyreállítás
  </button>
}
